import { formatDate } from "@tillix/utils/format";
import { matchesGlobalFilter } from "../../utils/matches-global-filter";
import type { MeterReadingModel } from "../../../mobx/core/meter/model.meter-reading";

export function meterReadingMatchesGlobalFilter(
  row: MeterReadingModel,
  query: string,
  options?: { includeMeter?: boolean },
): boolean {
  const searchableValues = [
    row.consumption,
    row.daysInCycle,
    row.unitOfMeasure,
    row.cost,
    row.registerNum,
    row.runningReading,
    row.measuredAt.toISOString(),
    ...(options?.includeMeter ? [row.meter?.meterNum] : []),
    formatDate(row.measuredAt, undefined, {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
    }),
  ];

  return matchesGlobalFilter(query, searchableValues);
}
